import * as React from "react"
import { useEffect } from "react"
import { number, object } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { DIPSku } from "@components"
import { BACKEND_APIS } from "@constants"
import { brand, category } from "@signals"
import { useAdminSkuModal } from "../../@hooks"
import { adminSkuModalData, adminSkuModalErrors, adminSkuSavingData, adminSkuSelectedRows } from "../../@signals"


export default function AdminSkuModalSkuSelector() {
    const { localValue, handleChange } = useAdminSkuModal("sku")

    const { errors } = useValidatorSeeker({
        sku: localValue,
    }, object({
        sku: number().required("SKU is mandatory")
    }))

    useEffect(() => {
        adminSkuModalErrors.value = {
            ...adminSkuModalErrors.value,
            sku: errors?.sku
        }
    }, [errors?.sku])

    const showSkuInfo = (e, op) => {
        const selectedSku = e.target.value
        handleChange(selectedSku, { skuName: op.label })

        const data = adminSkuSavingData.value
        const skuData = data.find((row) => row.skuID === selectedSku)

        if (skuData) {
            adminSkuModalData.value = {
                ...adminSkuModalData.value,
                imageURL: skuData.imageURL,
                category: skuData.category,
                brand: skuData.brand,
                ean: skuData.ean,
                availablePricing: skuData.availables.available_pricing,
                availableMarketplaces: skuData.availables.available_marketplaces,
            }
        }
    }

    return <DIPSku
        multiple={false}
        urlAjax={`${BACKEND_APIS.MASTER_DATA}/sku/find`}
        label="SKU Target"
        placeholder="Please select a SKU to merge"
        error={errors?.sku}
        value={localValue || ""}
        filters={{
            category: category.value,
            brand: brand.value,
            excluded: adminSkuSelectedRows.value
        }}
        onChange={showSkuInfo}
    />
}